import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import {Component, Inject, Input} from "@angular/core"
import { ApiService } from "../../services/api.service"
import { TranslateService } from "../../services/translate.service"
import { AuthService } from "../../services/auth.service"
import { DialogButtonComponent } from "../buttons/dialog-button.component"
import { CommonModule } from "@angular/common"
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {LoadingSpinnerComponent} from './loading-spinner-component';
import {AuthorizedApiService} from '../../services/authorized-api.service';

@Component({
  selector: 'app-add-loyalty',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DialogButtonComponent,
    CommonModule,
    ActionButtonComponent,
    LoadingSpinnerComponent,
  ],
  template: `
    <div class="mt-1 relative">
      <div class="" [formGroup]="loyaltyNumber">
        <div class="mb-1 font-bold">{{ getString("Lojalitetsnummer") }}</div>
        <input
          type="number"
          formControlName="email"
          [placeholder]="getString('nummer')"
          class="text-input"
        />
        <div *ngIf="errorMsg" class="mt-4 text-red-500">{{ errorMsg }}</div>
      </div>
      <div class="my-8 w-full">
        <app-action-button
          [text]="getString('Lägg till')"
          [disabled]="numberControl.invalid || isWorking"
          [icon]="'fa-square-plus'"
          [chevron]="false"
          (onClick)="send()">
        </app-action-button>
      </div>
      <div *ngIf="isWorking"
           class="absolute bottom-0 top-0 left-0 right-0 bg-white/50 flex items-center justify-center">
        <app-loading-spinner></app-loading-spinner>
      </div>
    </div>
  `
})
export class AddLoyaltyComponent {

  isWorking: boolean = false;
  loyaltyNumber!: FormGroup
  errorMsg?: string

  constructor(public api: AuthorizedApiService, private translate: TranslateService, private auth: AuthService,
              private sheetService: BottomSheetService) {
  }

  ngOnInit() {
    this.loyaltyNumber = new FormGroup({
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
    }, {
      updateOn: 'change'
    })

  }

  getString(s: string) {
    return this.translate.getString(s)
  }

  get numberControl() {
    return this.loyaltyNumber.controls["email"]!
  }

  send() {
    this.isWorking = true
    const identity = this.numberControl.value.toString()
    this.api.connectToLoyaltyPrograms(identity).subscribe({
      next: () => {
        this.isWorking = false
        this.sheetService.popSheet();
      },
      error: err => {
        console.log('Error:', err);
        this.isWorking = false
        this.errorMsg = err?.error?.message || this.getString("Något gick fel")
      }
    })
  }
}
